import { createAnimationsFromSequence } from './basler-components.es832.js';
import { animateSubject } from './basler-components.es703.js';
import { spring } from './basler-components.es747.js';

function animateSequence(sequence, options, scope) {
    const animations = [];
    const animationDefinitions = createAnimationsFromSequence(sequence, options, scope, { spring });
    animationDefinitions.forEach(({ keyframes, transition }, subject) => {
        animations.push(...animateSubject(subject, keyframes, transition));
    });
    return animations;
}

export { animateSequence };
